import { PayloadAction } from '@reduxjs/toolkit';
import { call, takeLatest } from 'redux-saga/effects';

import {
  ApiKeyService,
  ApiKeyServiceCreateRequest,
  ApiKeyServiceDeleteRequest,
} from 'api/auth/api.pb';
import { callApiFn } from 'utils/saga';

import { actions } from './slice';

export function* apiKeysSaga() {
  yield takeLatest(actions.getApiKeys.type, doGetApiKeys);
  yield takeLatest(actions.createApiKey.type, doCreateApiKey);
  yield takeLatest(actions.revokeApiKey.type, doRevokeApiKey);
}

export function* doGetApiKeys() {
  yield call(callApiFn, {
    fn: ApiKeyService.List,
    data: {},
    onSuccess: actions.getApiKeysSuccess,
    onError: actions.getApiKeysError,
    errorTitle: 'Failed to load API keys',
  });
}

export function* doCreateApiKey(
  action: PayloadAction<ApiKeyServiceCreateRequest>,
) {
  yield call(callApiFn, {
    fn: ApiKeyService.Create,
    data: action.payload,
    onSuccess: actions.createApiKeySuccess,
    onError: actions.createApiKeyError,
    errorTitle: 'Failed to create API key',
  });
}

export function* doRevokeApiKey(action: PayloadAction<{ id: string }>) {
  const data: ApiKeyServiceDeleteRequest = { id: action.payload.id };

  yield call(callApiFn, {
    fn: ApiKeyService.Delete,
    data,
    onSuccess: actions.revokeApiKeySuccess,
    onError: actions.revokeApiKeyError,
    errorTitle: 'Failed to revoke API key',
  });
}
